export default function ErrorBoundary({ fromPage }: { fromPage: string }) {
  return (
    <>
      <title>Something Went Wrong...</title>
      {/* <link rel="canonical" href={`https://www.${domain}`} /> */}

      <div className="container-fluid but-fixed">
        <div className="row justify-content-center">
          <div className="col-12 pt-3 pt-md-4">
            <h3>Something Went Wrong...</h3>
            <p>Error on: {fromPage}</p>
          </div>
        </div>
      </div>
    </>
  );
}
